module.exports = __webpack_public_path__ + "img/head_pic.c03d12f5.png";